import { BaseService } from './base.service';

export class OrderStaffsService extends BaseService {
  static get resourceEndpoint() {
    return 'order_staffs';
  }
}
